import type { Vaccine } from '../data/pediatric';

const AGE_GROUPS = [
  { label: 'RN', min: 0, max: 1 },
  { label: '2m', min: 1, max: 3 },
  { label: '4m', min: 3, max: 5 },
  { label: '6m', min: 5, max: 8 },
  { label: '9m', min: 8, max: 11 },
  { label: '12m', min: 11, max: 14 },
  { label: '15m', min: 14, max: 17 },
  { label: '18m', min: 17, max: 21 },
  { label: '24m', min: 21, max: 30 },
  { label: '36m', min: 30, max: 42 },
  { label: '48m', min: 42, max: 54 },
  { label: '60m', min: 54, max: Infinity },
];

export function getAgeGroup(birthDate: string): string {
  const birth = new Date(birthDate);
  const now = new Date();

  let months =
    (now.getFullYear() - birth.getFullYear()) * 12 +
    (now.getMonth() - birth.getMonth());

  if (now.getDate() < birth.getDate()) {
    months--;
  }

  if (months < 0) months = 0;
  if (months > 60) return '60m';

  for (const group of AGE_GROUPS) {
    if (months >= group.min && months < group.max) {
      return group.label;
    }
  }

  return '60m';
}

export function getVaccinesForAge(
  ageMonths: number,
  vaccines: Vaccine[]
): Vaccine[] {
  return vaccines
    .filter((v) => v.age_months <= ageMonths)
    .sort((a, b) => a.age_months - b.age_months);
}
